<template>
  <div class="row q-mb-lg">
    <div class="col-xs-12 col-sm-6">
      <common-input
          v-model="form.name"
          label="Naam"
          name="name"
          :error-message="$errorMessage('name')"
          :error="$hasError('name')"
          required
          autofocus
      />
    </div>
  </div>
  <div class="row q-mb-lg">
    <div class="col-xs-12 col-sm-6">
      <common-input
          v-model="form.description"
          label="Omschrijving"
          name="description"
          :error-message="$errorMessage('description')"
          :error="$hasError('description')"
      />
    </div>
  </div>
  <div class="row">
    <option-group
        v-model="form.permission_ids"
        :options="optionsArray"
        label="Rechten"
        name="permission_ids[]"
        :error-message="$errorMessage('permission_ids')"
        :error="$hasError('permission_ids')"
        type="checkbox"
    />
  </div>
</template>

<script>
import { permissionTranslations } from '~HIOR/constants'

export default {
  props: {
    role: {
      type: Object,
      default: () => ({}),
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    permission_ids: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      form: {
        name: this.$old('name', this.role?.name),
        description: this.$old('description', this.role?.description),
        permission_ids: [...this.permission_ids],
      },
    }
  },
  computed: {
    optionsArray () {
      return this.permissions.filter(permission => {
        return !!permissionTranslations[permission.name]
      }).map(permission => {
        return {
          value: permission.id,
          label: `${permissionTranslations[permission.name]} - ${permission.description}`,
        }
      })
    },
  },
}
</script>
